module.exports = __webpack_public_path__ + "img/sreekanth-pic.d95a1b6f.jpg";